const UPDATE_CONCURRENT_USERS = 'UPDATE-CONCURRENT-USERS';

export { UPDATE_CONCURRENT_USERS };
